import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import Topic from "./topic"
import mount from "core/mount"

import "./notifications.css"

import Popover, { PopoverButton, PopoverContent } from "@kit/design/popover"
import VisuallyHidden from "@kit/design/visually-hidden"

const listenToTriggers = callback => {
  window.addEventListener("notifications:refresh", callback)
}

const fetchList = async (path, setTopics) => {
  try {
    const response = await fetch(path)
    if (response.ok) {
      const json = await response.json()
      setTopics(json.notifications)
    }
  } catch (error) {
    console.error(error)
  }
}

const activeTopics = topics => {
  return topics.filter(
    topic => topic.status == "processing" || topic.status == "started"
  )
}

const getPathData = radius => {
  return `
    M 50, 50
    m 0,-${radius}
    a ${radius}, ${radius} 1 1 1 0, ${2 * radius}
    a ${radius},${radius} 1 1 1 0, -${2 * radius}
  `
}

const Notifications = props => {
  Notifications.propTypes = {
    path: PropTypes.string.isRequired
  }

  const [active, setActive] = useState(false)
  const [topics, setTopics] = useState([])
  const radius = 40
  const diameter = Math.PI * 2 * radius

  useEffect(() => {
    fetchList(props.path, setTopics)
    listenToTriggers(() => fetchList(props.path, setTopics))
  }, [])

  useEffect(() => {
    setActive(activeTopics(topics).length > 0)
  }, [topics])

  if (!topics.length) return null

  if (topics[0].message.toLowerCase() === "your export link has expired.")
    return null

  return (
    <div id="Notifications" className="mr-3">
      <Popover label="bulk notifications" arrow={false}>
        <PopoverButton
          className="w-6 h-6 stroke-current focus:outline-none text-black mr-2"
          aria-controls="notificationMenu"
          style={{ opacity: "0.2" }}
        >
          <svg viewBox="0 0 100 100">
            <path
              d={getPathData(radius)}
              strokeWidth="20"
              fillOpacity="0"
              style={{
                strokeDasharray: `${diameter}px ${diameter}px`,
                strokeDashoffset: `${0 * diameter}px`
              }}
              className="background"
            />
            <path
              d={getPathData(radius)}
              strokeWidth="20"
              fillOpacity="0"
              style={{
                strokeDasharray: `${diameter}px ${diameter}px`,
                strokeDashoffset: `${active ? 0 : 1 * diameter}px`
              }}
              className="foreground"
            />
          </svg>
          <VisuallyHidden>Bulk Notifications</VisuallyHidden>
        </PopoverButton>

        <PopoverContent
          className="w-auto border-none shadow-lg rounded-lg"
          style={{ zIndex: 10000 }}
        >
          <ul className="p-0 list-none" id="notificationMenu" tabIndex={0}>
            {topics.map(topic => (
              <Topic key={topic.id} {...topic} />
            ))}
          </ul>
        </PopoverContent>
      </Popover>
    </div>
  )
}

mount({ Notifications })

export default Notifications
